import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { hasValidAuthToken } from "../Utils/auth";

// Only users who arrived with a valid userToken (stored by Utils/captureUserToken) may enter.
// Re-checked on every navigation so an expired token is caught when moving between pages.
const ProtectedRoute = () => {
  useLocation();

  if (!hasValidAuthToken()) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
